import React, { useState } from 'react';
import users from '../data/users.json';
import './Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    await new Promise(resolve => setTimeout(resolve, 800));

    const user = users.users.find(
      u => u.username.toLowerCase() === username.toLowerCase() && u.password === password
    );

    if (user) {
      onLogin(user);
    } else {
      setError('Invalid username or password');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left Side - Branding */}
      <div className="login-left">
        <div className="login-brand">
          <div className="login-logo">
            <div className="login-logo-icon">R</div>
            <span className="login-logo-text">RMB Corporate Finance</span>
          </div>
          
          <h1 className="login-headline">
            AI-Powered Deal Intelligence
          </h1>
          <p className="login-subheadline">
            Transform corporate finance with intelligent agents that monitor markets, analyze opportunities, and accelerate deal execution.
          </p>

          <div className="login-stats">
            <div className="login-stat">
              <span className="login-stat-value">95%</span>
              <span className="login-stat-label">Deal Coverage</span>
            </div>
            <div className="login-stat">
              <span className="login-stat-value">6</span>
              <span className="login-stat-label">AI Agents</span>
            </div>
            <div className="login-stat">
              <span className="login-stat-value">35+</span>
              <span className="login-stat-label">African Markets</span>
            </div>
            <div className="login-stat">
              <span className="login-stat-value">24/7</span>
              <span className="login-stat-label">Monitoring</span>
            </div>
          </div>

          <div className="login-features">
            <div className="login-feature">
              <svg className="login-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Real-time market intelligence</span>
            </div>
            <div className="login-feature">
              <svg className="login-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Automated deal memo generation</span>
            </div>
            <div className="login-feature">
              <svg className="login-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Multi-jurisdiction regulatory tracking</span>
            </div>
          </div>
        </div>

        {/* Floating badges */}
        <div className="login-badges">
          <div className="login-badge badge-1">
            <span className="badge-dot success"></span>
            HOT Deal Identified
          </div>
          <div className="login-badge badge-2">
            <span className="badge-dot info"></span>
            Signal Detected
          </div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="login-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Welcome back</h2>
            <p>Sign in to access your AI agents</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                autoComplete="username"
                disabled={isLoading}
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
                disabled={isLoading}
              />
            </div>

            {error && (
              <div className="login-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v4m0 4h.01" />
                </svg>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="login-button"
              disabled={isLoading || !username || !password}
            >
              {isLoading ? (
                <>
                  <span className="login-spinner" />
                  Signing in...
                </>
              ) : (
                'Continue'
              )}
            </button>
          </form>

        </div>

        <div className="login-demo-note">
          Demo Environment - Use provided credentials
        </div>
      </div>
    </div>
  );
};

export default Login;
